import React, { useContext } from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import { get } from 'lodash'
import Button from '../button'
import Popover from '../popover'
import Row from '../row'
import Divider from '../divider'
import ActionsContext from './ActionsContext'
import images from './images'
import { getLanguageStore, clearLoginCookie } from './storage'

const Avatar = styled.li`
  margin-right: 0;
  font-size: 0;
  img {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    cursor: pointer;
    .large-size & {
      width: 32px;
      height: 32px;
    }
  }
`

const GlobalStyle = createGlobalStyle`
    .tnt-layout-personal-popover {
        .ant-popover-inner-content {
            padding: 0;
        }
    }
`

const UserInfoWrapper = styled.div`
  min-width: 235px;
  z-index: 1;
  background-color: #fff;
  border-radius: 4px;

  .isInIframe & {
    display: none;
  }

  .user-info-body {
    padding: 30px 20px 20px 24px;
    line-height: 16px;
    .user-info-body-username {
      margin-top: 0px;
      font-size: 16px;
      color: #333;
      font-weight: normal;
      margin-bottom: 10px;
      line-height: 16px;
    }
    .user-info-body-account {
      margin-top: 0px;
      color: #666;
      margin-bottom: 14px;
      line-height: 16px;
    }
    a {
      margin-right: 16px;
    }
  }
  .user-info-footer {
    border-top: ${(props) => `1px solid ${props.theme.dividerColor}`};
    background-color: #fff;
    height: 36px;
    line-height: 36px;
    padding: 0 15px;
    font-size: 12px;
    color: ${(props) => `${props.theme.primaryColor}`};
    a {
      flex: 1;
      text-align: center;
      color: ${(props) => `${props.theme.primaryColor}`};
    }
  }
`

const UserInfoContent = (props) => {
  const {
    userInfo,
    onLogout,
    onChangePassword = () => true,
    onPersonalSetting = () => true,
  } = props
  const { getText } = useContext(ActionsContext)

  return (
    <UserInfoWrapper className="user-info-setting-wrap">
      <div className="user-info-body">
        <p className="user-info-body-username">{userInfo.userName || getText('nameNull')}</p>
        <p className="user-info-body-account">{userInfo.account}</p>
      </div>
      <Row className="user-info-footer" type="flex" justify="space-between" align="middle">
        <a onClick={onPersonalSetting} href="/bridge/userCenter?currentTab=1">
          {getText('personalSettings')}
        </a>
        <Divider type="vertical" />
        <a
          onClick={onChangePassword}
          href="/bridge/userCenter?currentTab=2"
          style={getLanguageStore() === 'en' ? { flex: 2 } : {}}
        >
          {getText('changePwd')}
        </a>
        <Divider type="vertical" />
        <a
          className="user-info-footer-signout"
          onClick={() => {
            if (onLogout) {
              onLogout()
              clearLoginCookie()
            } else {
              clearLoginCookie()
              window.location.href = `/user/login?callbackUrl=${window.encodeURI(location.href)}`
            }
          }}
        >
          {getText('signOut')}
        </a>
      </Row>
    </UserInfoWrapper>
  )
}

export default (props) => {
  const { userInfo = {} } = props
  const { avatar } = userInfo

  return (
    <Avatar>
      <Popover
        popupClassName="tnt-layout-personal-popover"
        placement="bottomRight"
        title={null}
        content={<UserInfoContent {...props} />}
        trigger="click"
      >
        {avatar ? (
          <img
            src={
              avatar.indexOf('base64') > 0 ? avatar : get(images[avatar], 'default', images[avatar])
            }
            onError={(e) => {
              e.target.onerror = null
              e.target.src = images.empty?.default || images.empty
            }}
          />
        ) : (
          <img src={images.empty?.default || images.empty} />
        )}
      </Popover>
      <GlobalStyle />
    </Avatar>
  )
}
